import React from 'react';

const specificLink = (
  <a target="_blank" rel="noopener noreferrer" href="//www.edmunds.com/about/privacy.html">
    <u>Edmunds collection and use of your personal information</u>
  </a>
);

const specificDisclaimerSingle = ctaText => {
  return (
    <>
      By clicking {ctaText}, I agree that this information will be provided to this dealer and the vehicle manufacturer
      and its vendor. See {specificLink}. Edmunds will not share this information with any other dealer.
    </>
  );
};
const specificDisclaimerMulti = ctaText => {
  return (
    <>
      By clicking {ctaText}, I agree that this information will be provided to the dealers that I selected and the
      vehicle manufacturer and its vendor. See {specificLink}. Edmunds will not share this information with any dealers
      other than those that you selected.
    </>
  );
};

const baseLink = (
  <a target="_blank" rel="noopener noreferrer" href="//www.edmunds.com/about/privacy.html">
    <u>Our collection and use of your personal information</u>
  </a>
);

const baseDisclaimerSingle = () => {
  return <>This information will not be shared with any dealer other than the one offering this vehicle. {baseLink}</>;
};
const baseDisclaimerMulti = () => {
  return <>This information will not be shared with any dealer other than those you select. {baseLink}</>;
};

const DISCLAIMERS_MAP = {
  'specific-single': specificDisclaimerSingle,
  'specific-multi': specificDisclaimerMulti,
  'basic-single': baseDisclaimerSingle,
  'basic-multi': baseDisclaimerMulti,
};

export const getDisclaimerCopy = (disclaimerType, isSingleSelect, ctaText) => {
  const suffix = isSingleSelect ? 'single' : 'multi';
  const fullDisclaimerName = `${disclaimerType}-${suffix}`;
  const disclaimerFunction = DISCLAIMERS_MAP[fullDisclaimerName];

  return disclaimerFunction(ctaText);
};
